import axios from "axios";
import instance,{BASE_URL} from "../../services/api";
import toast from 'react-hot-toast';

const EmployeeTaxSlabVeiwController = () => {
  const getErrorMessage = (error) => {
  return (
    error.response?.data?.detail ||   // Django REST Framework style
    error.response?.data?.message ||  // custom backend message
    error.response?.data?.error ||    // another fallback
    error.message ||                  // Axios default
    "Something went wrong!"
  );
};
  const getemployeeTax = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(
        `${BASE_URL}company-tax-slabs/`
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "GET_EMPLOYEE_TAX_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      //  const message = getErrorMessage(error);
      dispatch({
        type: "GET_EMPLOYEE_TAX_FAILURE",
        payload: { error: error }
      });
      // toast.error(message);
    }
  };

  const addEmployeeTax = (reqData) => async (dispatch) => {
  dispatch({ type: "LOADING", payload: true });

  const authToken = localStorage.getItem("access_token");
  const axiosInstance = axios.create({
    baseURL: `${BASE_URL}`,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${authToken}`,
    },
  });

  try {
    const response = await axiosInstance.post("company-tax-slabs/", reqData);
    const data = response.data;

    dispatch({ type: "ADD_EMPLOYEE_TAX_SUCCESS", payload: data });
    dispatch(getemployeeTax());
    toast.success("Employee tax added successfully");
    return Promise.resolve(data);
  } catch (error) {
    dispatch({ type: "ADD_EMPLOYEE_TAX_FAILURE", payload: { error } });
    const message = getErrorMessage(error);
    toast.error(message);
    return Promise.reject(error);
  } finally {
    dispatch({ type: "LOADING", payload: false });
  }
};

const updateEmployeeTax = (id, reqData) => async (dispatch) => {
  dispatch({ type: "LOADING", payload: true });

  const authToken = localStorage.getItem("access_token");
  const axiosInstance = axios.create({
    baseURL: `${BASE_URL}`,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${authToken}`,
    },
  });

  try {
    const response = await axiosInstance.put(
      `company-tax-slabs/${id}/`,
      reqData
    );
    const data = response.data;

    dispatch({ type: "UPDATE_EMPLOYEE_TAX_SUCCESS", payload: data });
    dispatch(getemployeeTax());
    toast.success("Tax slab updated successfully");
    return Promise.resolve(data);
  } catch (error) {
    dispatch({ type: "UPDATE_EMPLOYEE_TAX_FAILURE", payload: { error } });
    const message = getErrorMessage(error);
    toast.error(message);
    return Promise.reject(error);
  } finally {
    dispatch({ type: "LOADING", payload: false });
  }
};


  const deleteEmployeeTax = (taxId) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.delete(
        `${BASE_URL}company-tax-slabs/${taxId}/`
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "DELETE_EMPLOYEE_TAX_SUCCESS", payload: data });
      dispatch(getemployeeTax());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Tax slab deleted sucessfully");
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "DELETE_EMPLOYEE_TAX_FAILURE",
        payload: { error: error }
      });
      toast.error(message);
    }
  };
 
  
  return {
    getemployeeTax,
    addEmployeeTax,
    updateEmployeeTax,
    deleteEmployeeTax
  };
};

export default EmployeeTaxSlabVeiwController;
